// src/components/AuthLanding.js
import React from "react";
import { Container, Paper, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import Login from "./Login";
import Register from "./Register";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

const AuthLanding = ({
  openRegister,
  setOpenRegister,
  onRegisterSuccess,
  waitingForVerification,
  setWaitingForVerification,
}) => {
  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 3, textAlign: "center" }}>
        {/* Pass the onUnverifiedAttempt callback to Login */}
        <Login onUnverifiedAttempt={() => setWaitingForVerification(true)} />
        <Typography
          variant="body2"
          sx={{
            mt: 2,
            cursor: "pointer",
            color: "primary.main",
            textDecoration: "underline",
          }}
          onClick={() => setOpenRegister(true)}
        >
          Don't have an account? Register here.
        </Typography>
      </Paper>

      {/* Registration Modal */}
      <Dialog
        open={openRegister}
        onClose={() => setOpenRegister(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          Create an Account
          <IconButton
            aria-label="close"
            onClick={() => setOpenRegister(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Register
            onRegisterSuccess={() => {
              onRegisterSuccess();
              setOpenRegister(false);
            }}
          />
        </DialogContent>
      </Dialog>

      {/* Waiting-for-Verification Modal */}
      <Dialog
        open={waitingForVerification}
        onClose={() => setWaitingForVerification(false)}
      >
        <DialogTitle>Verification Required</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Your email address is not verified.
            <br />
            Please check your inbox (or spam folder) for the verification email and click the link provided.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setWaitingForVerification(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default AuthLanding;